module.exports = __webpack_public_path__ + "static/media/Prof. Martin Green.6a7e17e5.png";